import { render, staticRenderFns } from "./TaskReportTab.vue?vue&type=template&id=56d21ca8&scoped=true&"
import script from "./TaskReportTab.vue?vue&type=script&lang=js&"
export * from "./TaskReportTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d21ca8",
  null
  
)

export default component.exports